import { getGraphHeaders } from '@/utils/getGraphHeaders';
import { logWarning } from '@/utils/miscUtils';
import { BffBrandType } from '@/types/generated';

export const getBffFacilitiesByAddress = async (
	brand: BffBrandType,
	address: string,
	url: string,
	fetchAllIfNoResults: boolean | undefined,
	appName: string,
	appVersion: string
) => {
	try {
		if (!brand) {
			return null;
		}
		const { getGraphQLClient } = await import(
			/* webpackChunkName:"getGraphQLClient" */ '../graphql/getGraphQLClient'
		);
		return await getGraphQLClient(url).bffFacilitiesByAddress(
			{
				brand,
				address,
				fetchAllIfNoResults,
			},
			getGraphHeaders(appName, appVersion)
		);
	} catch (err) {
		logWarning(`Could not find any facilities data for: ${brand} for query: ${address}`);
	}
};
